/* ==========================================================================
   CL · Vitrina PIN — comportamiento
   - Click en un pin → dropdown con el producto linkeado.
     · Desktop: el drop NACE del pin (anclado a su posición, con origen
       en el pin y clamping para no salirse del marco; si el pin está
       muy abajo, el drop abre hacia arriba).
     · Mobile: el drop nace ABAJO de la imagen (panel deslizante).
   - Solo un drop abierto a la vez; click fuera o Escape cierran.
   ========================================================================== */

(function () {
	'use strict';

	function isMobile() {
		return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
	}

	/* La capa de pines se ancla a la CAJA PINTADA de la imagen (no al
	   marco): con object-fit:cover, la imagen se re-escala y recorta
	   distinto según el ancho del viewport, y los pines en % del marco
	   se desalineaban de la imagen (se "bajaban" al ver la página en un
	   ancho distinto al del editor). Con esto, el % siempre es % de la
	   imagen real, a cualquier tamaño. */
	function layoutPinLayer(root) {
		var frame = root.querySelector('.clpin__frame');
		var layer = root.querySelector('.clpin__pinlayer');
		if (!frame || !layer) return;
		var img = null;
		frame.querySelectorAll('.clpin__img').forEach(function (i) {
			if (i.getClientRects().length) img = i; /* la visible (desk o mobile) */
		});
		if (!img || !img.naturalWidth || !img.naturalHeight) {
			layer.style.left = '';
			layer.style.top = '';
			layer.style.width = '';
			layer.style.height = '';
			return;
		}
		var fw = frame.clientWidth;
		var fh = frame.clientHeight;
		var scale = Math.max(fw / img.naturalWidth, fh / img.naturalHeight);
		var w = img.naturalWidth * scale;
		var h = img.naturalHeight * scale;
		layer.style.width = w + 'px';
		layer.style.height = h + 'px';
		layer.style.left = (fw - w) / 2 + 'px';
		layer.style.top = (fh - h) / 2 + 'px';
	}

	function initSection(root) {
		if (root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var frame = root.querySelector('.clpin__frame');
		var drop = root.querySelector('.clpin__drop');
		var mpanel = root.querySelector('.clpin__mpanel');
		var pins = [].slice.call(root.querySelectorAll('.clpin__pin'));
		if (!frame || !pins.length) return;

		/* Ancla la capa de pines a la imagen: al cargar cada imagen,
		   al redimensionar y al inicio */
		layoutPinLayer(root);
		frame.querySelectorAll('.clpin__img').forEach(function (img) {
			if (img.complete) return;
			img.addEventListener('load', function () {
				layoutPinLayer(root);
			}, { once: true });
		});
		window.addEventListener('load', function () {
			layoutPinLayer(root);
		}, { once: true });

		var activePin = null;

		function fill(container, pin) {
			var title = container.querySelector('[data-drop-title]');
			var price = container.querySelector('[data-drop-price]');
			var compare = container.querySelector('[data-drop-compare]');

// 			try{
// price.classList.remove("wpd-processed");
// price.setAttribute("data-wpd-variant-compare-at-price",variant.compare_at_price == null ? "":variant.compare_at_price);
// price.setAttribute("data-wpd-variant-price",variant.price);
// price.setAttribute("data-wpd-variant-id",variant.id);
// price.setAttribute("data-wpd-product-handle",window.wpdExtensionIsProductPage.handle);
// }catch(e){}

			var btn = container.querySelector('[data-drop-btn]');
			if (title) title.textContent = pin.dataset.title || '';
			if (price) price.textContent = pin.dataset.price || '';
			if (compare) {
				compare.textContent = pin.dataset.compare || '';
				compare.style.display = pin.dataset.compare ? '' : 'none';
			}
			if (btn) {
				if (pin.dataset.url) {
					btn.setAttribute('href', pin.dataset.url);
					btn.style.display = '';
				} else {
					btn.style.display = 'none';
				}
			}
		}

		function closeAll() {
			if (drop) drop.classList.remove('is-open');
			if (mpanel) mpanel.classList.remove('is-open');
			pins.forEach(function (p) {
				p.setAttribute('aria-expanded', 'false');
			});
			activePin = null;
		}

		function openDesktop(pin) {
			if (!drop) return;
			fill(drop, pin);
			// medir sin parpadeo
			drop.style.visibility = 'hidden';
			drop.classList.add('is-open');
			var fr = frame.getBoundingClientRect();
			var pr = pin.getBoundingClientRect();
			var dw = drop.offsetWidth;
			var dh = drop.offsetHeight;
			var left = pr.left - fr.left + pr.width / 2 - dw / 2;
			left = Math.max(10, Math.min(left, fr.width - dw - 10));
			var top = pr.bottom - fr.top + 10;
			var originY = 'top';
			if (top + dh > fr.height - 10) {
				top = pr.top - fr.top - dh - 10;
				originY = 'bottom';
			}
			// origen hacia el pin para que "nazca" de él
			var originX = pr.left - fr.left + pr.width / 2 - left;
			drop.style.left = left + 'px';
			drop.style.top = top + 'px';
			drop.style.transformOrigin = originX + 'px ' + (originY === 'top' ? '0%' : '100%');
			// reinicia la animación
			drop.classList.remove('is-open');
			void drop.offsetWidth;
			drop.style.visibility = '';
			drop.classList.add('is-open');
		}

		function openMobile(pin) {
			if (!mpanel) return;
			fill(mpanel, pin);
			mpanel.classList.add('is-open');
		}

		function toggle(pin) {
			if (activePin === pin) {
				closeAll();
				return;
			}
			closeAll();
			activePin = pin;
			pin.setAttribute('aria-expanded', 'true');
			if (isMobile()) {
				openMobile(pin);
			} else {
				openDesktop(pin);
			}
		}

		pins.forEach(function (pin) {
			pin.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				toggle(pin);
			});
		});

		if (drop) {
			drop.addEventListener('click', function (e) {
				e.stopPropagation();
			});
		}
		if (mpanel) {
			mpanel.addEventListener('click', function (e) {
				e.stopPropagation();
			});
		}

		document.addEventListener('click', function () {
			if (activePin) closeAll();
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && activePin) closeAll();
		});

		var resizeTimer;
		window.addEventListener(
			'resize',
			function () {
				window.clearTimeout(resizeTimer);
				resizeTimer = window.setTimeout(function () {
					closeAll();
					layoutPinLayer(root);
				}, 120);
			},
			{ passive: true }
		);
	}

	function initAll() {
		document.querySelectorAll('.clpin').forEach(initSection);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
